<!--
  - Copyright (c) Interactive Information R & D (I2RD) LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - I2RD LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with I2RD.
  -->

<!-- Header shown on the content section (rather than the page's header). Consists of title and back button, if enabled -->
<template>
  <div class="header">
    <div class="back-nav">
      <v-btn
        class="back-button"
        v-if="backNavigation"
        text
        :to="backNavigationTo"
        :href="backNavigationHref"
        exact
      >
        <v-icon left>mdi-chevron-left</v-icon>
        {{ backNavigationText }}
      </v-btn>
    </div>
    <div class="mb-4 d-flex">
      <h1 class="page-title">
        <v-icon v-if="headerIcon" large color="#3a3a3a">
          {{ headerIcon }}
        </v-icon>
        {{ headerTitle }}
      </h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContentHeader",
  props: {
    headerIcon: {
      type: String
    },
    headerTitle: {
      type: String,
      default: "Details"
    },
    backNavigation: Boolean,
    backNavigationText: {
      type: String,
      default: "Back"
    },
    backNavigationTo: {
      type: String,
      default: null
    },
    backNavigationHref: {
      type: String,
      default: null
    }
  }
};
</script>
